module.exports = __webpack_public_path__ + "img/Dantam Hair 54.324e4781.jpg";